






import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';

@Component({
    mixins: [InputMixin]
})
export default class CheckboxInput extends Mixins<InputMixin>(InputMixin) {
    @Prop({default: 'codeValue'}) private readonly valueName: string;
    @Prop({default: 'codeLabel'}) private readonly labelName: string;
    @Prop({default: true}) private readonly vertical: boolean;
    @Prop({default: () => []}) private readonly options: any[];
    
    get checked() {
        const values = this.value ? this.value.split(',') : [];
        return (element: any) => {
            return values.find((value: any) => element[this.valueName] === value) !== undefined;
        };
    }
    
    get elementId() {
        return (index: number) => {
            return `${this.getId}_${index}`;
        };
    }
    
    get elements() {
        return this.options;
    }
    
    get checkboxWrapStyle() {
        return {
            'vertical': this.vertical
        };
    }

    public getCheckedOptions() {
        return this.value
            ? this.value
                  .split(',')
                  .filter((value: any) => value !== '' && value !== undefined)
            : [];
    }
    
    public onInputChange(element: any) {
        let values = this.getCheckedOptions();
        if (values.find((val: any) => val === element[this.valueName]) === undefined) {
            values.push(element[this.valueName]);
        } else {
            values = values.filter((val: any) => val !== element[this.valueName]);
        }

        const value = values.sort().join(',');
        this.$emit('input', value);

        if (this.changeDetectable) {
            this.$store.commit('commitValue', {
                itemId: this.getId,
                value,
                originValue: this.originValue
            });
        }
    }
}
